var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cv-search',_vm._g(_vm._b({staticClass:"cv-toolbar-search",attrs:{"kind":"toolbar","form-item":false,"value":_vm.value,"small":""},on:{"focus":_vm.onFocus,"blur":_vm.onBlur}},'cv-search',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }